import { createSlice } from '@reduxjs/toolkit';

import requestQuantitySavingsQuantityReducer from './reducer/requestQuantitySavingsQuantityReducer';
import setQuantitySavingsQuoteReducer from './reducer/setQuantitySavingsQuoteReducer';
import { QuantitySavingsState } from './types';

export const quantitySavingsInitialState: QuantitySavingsState = {
  quote: undefined,
  sequence: 0,
  pendingQuantity: undefined,
  lastQuantity: undefined,
};

export const slice = createSlice({
  name: 'quantitySavings',
  initialState: quantitySavingsInitialState,
  reducers: {
    setQuantitySavingsQuoteAction: setQuantitySavingsQuoteReducer,
    requestQuantitySavingsQuantityAction: requestQuantitySavingsQuantityReducer,
  },
});

export const { setQuantitySavingsQuoteAction, requestQuantitySavingsQuantityAction } = slice.actions;

const quantitySavingsReducer = slice.reducer;

export default quantitySavingsReducer;
